export const HeaderPlatFormItemList = [
  {
    name: {
      fa: "لیست اساتید",
      en: "Teaches list",
    },
    need_login: false,
    icon: "",
    url: "/find-teachers",
    force: true,
  },
  {
    name: {
      fa: "بلاگ",
      en: "Blog",
    },
    need_login: false,
    icon: "",
    url: "/blog",
    newTab: true,
  },
  // {
  //     name: {
  //         'fa': 'چگونه کار می کند؟',
  //         'en': 'Teaches list'
  //     },
  //     need_login: false,
  //     icon: '',
  //     url: '/teachers-list'
  // },
  // {
  //     name: {
  //         'fa': 'وبلاگ',
  //         'en': 'Teaches list'
  //     },
  //     need_login: false,
  //     icon: '',
  //     url: '/teachers-list'
  // },
  // {
  //     name: {
  //         'fa': 'سوالات متداول',
  //         'en': 'Teaches list'
  //     },
  //     need_login: false,
  //     icon: '',
  //     url: '/teachers-list'
  // }
];

export const HeaderUserItemList = [
  {
    name: {
      fa: "داشبورد",
      en: "Dashboard",
    },
    need_login: true,
    icon: "",
    url: "/dashboard",
    roles: ["Teacher", "Student"],
  },
  {
    name: {
      fa: "تنظیمات استاد",
      en: "Lessons",
    },
    need_login: true,
    icon: "",
    url: "/profile",
    roles: ["Teacher"],
  },
];
